// extracted by mini-css-extract-plugin
export var content = "h_w";
export var icon = "h_D";
export var text = "h_P";
export var wrapper = "h_N";